module.exports = __webpack_public_path__ + "static/juan-46cd7db2e29e331bd52209d8658494b4.jpg";